import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M30.24 19.35a1 1 0 0 0 .11 1.41l13.114 11.234-13.115 11.247a1 1 0 1 0 1.302 1.518l14-12.006a1 1 0 0 0 0-1.518l-14-11.994a1 1 0 0 0-1.41.108",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M18.24 19.35a1 1 0 0 0 .11 1.41l13.113 11.234L18.35 43.241a1 1 0 0 0 1.302 1.518l14-12.006a1 1 0 0 0 0-1.518l-14-11.994a1 1 0 0 0-1.41.108",
		clipRule: "evenodd"
	})]
});
export default SvgExpand;
